<template lang="pug">
article
  //-
  //- Header section
  //-
  BackgroundImage(
    src="/images/bck_partners_p.jpg"
    alt="Partners"
    loading="eager"
    wrapper-class="header__image__background")

    header.header__image.margin-bottom-triple
      h1.header__image__title Partners
      .header__image__content
        p Grandes socios marcan la diferencia, por eso hemos preseleccionado a expertos en la emisión de instrumentos financieros con cobertura mundial, excelente track-record y una mentalidad innovadora.
        p Además, nuestro equipo le apoyará a lo largo de todo el proceso.
        h4.strong.gradient Queremos que nuestros clientes estén en las mejores manos.

  //-
  //- Law Firms
  //-
  section.section--partners
    .section__header
      h2.section__header__title {{ t('partners.lawFirms') }}

    .partners.grid--two--columns
      PartnerCard(
        v-for="partner in partners.lawFirms"
        :key="partner.company"
        :class="{ 'full--width': (partner.employees?.length ?? 0) >= 4 }"
        :partner="partner")

  //-
  //- MTF Advisors
  //-
  section.section--partners
    .section__header
      h2.section__header__title {{ t('partners.mtfAdvisors') }}

    .partners.grid--two--columns
      PartnerCard(
        v-for="partner in partners.mtfAdvisors"
        :key="partner.company"
        :partner="partner")

  //-
  //- Investment Firms
  //-
  section.section--partners
    .section__header
      h2.section__header__title {{ t('partners.investmentFirms') }}

    .partners.grid--two--columns
      PartnerCard(
        v-for="partner in partners.investmentFirms"
        :key="partner.company"
        :partner="partner")

  //-
  //- Listing and Corporate Services
  //-
  section.section--partners
    .section__header
      h2.section__header__title {{ t('partners.listingAndCorporateServices') }}

    .partners.grid--two--columns
      PartnerCard(
        v-for="partner in partners.listingAndCorporateServices"
        :key="partner.company"
        :partner="partner")

  //-
  //- Company and Assets Valuations
  //-
  section.section--partners
    .section__header
      h2.section__header__title {{ t('partners.companyAndAssetsValuations') }}

    .partners.grid--two--columns
      PartnerCard(
        v-for="partner in partners.companyAndAssetsValuations"
        :key="partner.company"
        :partner="partner")

  //-
  //- Capital Markets Advisors
  //-
  section.section--partners
    .section__header
      h2.section__header__title {{ t('partners.capitalMarketsAdvisors') }}

    .partners.grid--two--columns
      PartnerCard(
        v-for="partner in partners.capitalMarketsAdvisors"
        :key="partner.company"
        :partner="partner")

  //-
  //- Technology Providers
  //-
  section.section--partners.margin-bottom-quadruple
    .section__header
      h2.section__header__title {{ t('partners.technologyProviders') }}

    .partners.blocks--one--columns
      PartnerCard(
        v-for="partner in partners.technologyProviders"
        :key="partner.company"
        :partner="partner")

  //-
  //- Join us
  //-
  section
    Parallax(
      background="/images/bck_row8.jpg"
      text-size="small")
      h2 Buscamos a los mejores partners para nuestros clientes. Si su empresa tiene una sólida trayectoria, nos encantaría conocerle.
</template>

<script setup lang="ts">
  import { PartnerCard, partners } from '~/features/partner'

  //
  // Composables
  //

  const { t } = useI18n()
  definePageMeta({
    title: 'pages.partners.title',
    description: 'pages.partners.description',
    i18n: {
      locales: ['es'],
      paths: {
        es: '/portfolio-partners',
      },
    },
  })
</script>

<style lang="scss" scoped>
  .section--partners {
    margin-bottom: triple();
  }

  .section__header {
    margin-bottom: double();
  }

  .section__header__title {
    margin-bottom: 0;
    font-weight: font-weight(bold);
  }

  .partners {
    max-width: $page-width;
    margin: 0 auto;
    padding: 0 simple();
  }

  .partners--one-column {
    grid-template-columns: 1fr;
  }
</style>
